/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Why_TitleInputs */

const en_dr_why_title = /** @type {(inputs: Dr_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free canvases lose at convergence`)
};

const id_dr_why_title = /** @type {(inputs: Dr_Why_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kanvas bebas kalah di tahap konvergensi`)
};

/**
* | output |
* | --- |
* | "Free canvases lose at convergence" |
*
* @param {Dr_Why_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_why_title = /** @type {((inputs?: Dr_Why_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Why_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_why_title(inputs)
	return en_dr_why_title(inputs)
});